var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4385 0.00146484C12.7698 0.00159243 13.088 0.132401 13.3223 0.366699L17.9561 5.00146C18.1902 5.23585 18.3223 5.55391 18.3223 5.88525V17.5015C18.322 18.8818 17.2026 20.0013 15.8223 20.0015H5.82227C4.44171 20.0015 3.32252 18.882 3.32227 17.5015V2.50146C3.32227 1.12075 4.44155 0.00146484 5.82227 0.00146484H12.4385ZM6.44727 15.0015C6.10209 15.0015 5.82227 15.2813 5.82227 15.6265C5.82252 15.9714 6.10224 16.2515 6.44727 16.2515H11.4473C11.7921 16.2513 12.072 15.9713 12.0723 15.6265C12.0723 15.2814 11.7923 15.0017 11.4473 15.0015H6.44727ZM6.44727 12.5015C6.10209 12.5015 5.82227 12.7813 5.82227 13.1265C5.82252 13.4714 6.10224 13.7515 6.44727 13.7515H15.1973C15.5421 13.7513 15.822 13.4713 15.8223 13.1265C15.8223 12.7814 15.5423 12.5017 15.1973 12.5015H6.44727ZM6.44727 10.0015C6.10209 10.0015 5.82227 10.2813 5.82227 10.6265C5.82252 10.9714 6.10224 11.2515 6.44727 11.2515H15.1973C15.5421 11.2513 15.822 10.9713 15.8223 10.6265C15.8223 10.2814 15.5423 10.0017 15.1973 10.0015H6.44727ZM12.6973 4.37646C12.6975 5.06661 13.2571 5.62646 13.9473 5.62646H16.4473L12.6973 1.87646V4.37646Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.e2d741ce6154c65f9639775e1290b952.svg";
export { ForwardRef as ReactComponent };